import { Injectable } from '@angular/core';
import { Observable, throwError, firstValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { SharedService } from '../services/shared.service';
import { IBrandProfile } from '../interfaces/brand-profile';
import { IStateProvince } from '../interfaces/state-province';

@Injectable({
  providedIn: 'root'
})
export class BrandProfileService {

  private brandProfileUrl = '/client/brand-profile'; 
  private statesProvincesUrl = '/client/state-provinces';

  constructor(
    private http: HttpClient,
    private sharedService: SharedService
  ) { }

  public getBrandProfile(envRegion: string, sessionId: string): Observable<IBrandProfile> {
    let headers = new HttpHeaders()
      // .set('Authorization', this.sharedService.getAppBasicAuth())
      .set('session-id', sessionId);
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) + this.brandProfileUrl;
    return this.http.get<IBrandProfile>(url, { headers: headers, responseType: 'json'})
    .pipe(
//      catchError(this.sharedService.handleError)
      catchError(this.sharedService.handleError2<IBrandProfile>('validateCustomer' ))
    )
  }

  // Get a list of states | provinces
  public getStatesProvinces(): Observable<IStateProvince[]> {
    let envRegion: string = this.sharedService.getEnvRegion(); 
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) 
      + this.statesProvincesUrl;
    return this.http.get<IStateProvince[]>(url, {responseType: 'json'})
    .pipe(
        catchError(this.sharedService.handleError2<IStateProvince[]>('validateCustomer' ))
      )
  }   


}
